import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/ezOCM_Logo.png'; // Adjust path as needed
import { FaUser, FaSignOutAlt, FaChevronDown, FaBars } from 'react-icons/fa';

function Header({ pageTitle, sidebarPresent, onToggleMobileSidebar }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [user, setUser] = useState({ name: 'Change Manager' });
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const userData = JSON.parse(localStorage.getItem('ezocmUser'));
      if (userData && userData.name) {
        setUser(userData);
      }
    } catch (e) {
      console.error('Error loading user data:', e);
    }
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('ezocmUser');
    navigate('/');
  };

  const getInitials = (name) => {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase();
  };

  return (
    <header className={`app-header ${sidebarPresent ? 'with-sidebar' : ''}`}>
      <div className="header-left-section">
        {/* Mobile hamburger menu - only show when sidebar is present */}
        {sidebarPresent && (
          <button 
            className="mobile-hamburger"
            onClick={onToggleMobileSidebar}
            aria-label="Toggle sidebar"
          >
            <FaBars />
          </button>
        )}
        <img src={logo} alt="ezOCM Logo" className="header-logo" />
        {pageTitle && <h1 className="header-page-title">{pageTitle}</h1>}
      </div>

      <div className="header-user" ref={dropdownRef}>
        <button
          className="user-menu-button"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <div className="avatar">
            {getInitials(user.name)}
          </div>
          <span className="welcome-message">Welcome, {user.name}</span>
          <FaChevronDown className={`dropdown-icon ${isDropdownOpen ? 'open' : ''}`} />
        </button>
        
        {isDropdownOpen && (
          <div className="user-dropdown">
            <button onClick={() => navigate('/profile')} className="dropdown-item">
              <FaUser /> My Profile
            </button>
            <div className="dropdown-divider"></div>
            <button onClick={handleLogout} className="dropdown-item text-red-600">
              <FaSignOutAlt /> Sign Out
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;

